module.exports = __webpack_public_path__ + "static/Averta-Bold-c0aba073ef12cc8bae76d940188cf6a4.woff2";